import { DataClassName } from '@/Data/const'

export const getImageAlt: (dataClassName: string) => string | undefined = (
  dataClassName,
) => {
  switch (dataClassName) {
    case DataClassName.COMPANY:
      return 'building'
    case DataClassName.PERSON:
      return 'user-multiple'
    default:
      return undefined
  }
}
